import { AfterContentChecked, Component, OnInit } from '@angular/core';
import { PATHS } from '../../../analytics/constants/analytics.constants';
import { MapOverviewStatsComponent } from '../map-overview-stats/map-overview-stats.component';

@Component({
	selector: 'app-r4-map-overview-stats',
	styleUrls: ['./r4-map-overview-stats.component.css'],
	templateUrl: './r4-map-overview-stats.component.html'
})
export class R4MapOverviewStatsComponent extends MapOverviewStatsComponent implements OnInit, AfterContentChecked {
	public showStats = false;
	public isOverview: any;

	ngOnInit(): void {
		super.ngOnInit();
	}

	ngAfterContentChecked(): void {
		if (this.analyticsDataModel.getCurrentPath() === PATHS.OVERVIEW) {
			this.isOverview = true;
		} else {
			this.isOverview = false;
		}
	}

	toggleStats(): void {
		this.showStats = !this.showStats;
	}
}
